import type { DisplayConfigItem } from '@rsos/reduxDataStore/src/features/eventShare/types';

/** Share session lifetime — links expire after 24 hours per product spec (IAR-41050). */
export const SHARE_EXPIRY_SECONDS = 24 * 60 * 60;

export const CONSIST_SHARE_EXPIRY_SECONDS = 8 * 60 * 60;

/**
 * Display config items sent on every Field Share. The map is required so the
 * Connect Share view shown to recipients always includes the location pin
 * alongside any user-selected data sources.
 */
export const MAP_DISPLAY_CONFIG: DisplayConfigItem[] = [
  { name: 'map', meta: {} },
];
